import { create } from "zustand";

interface DocumentStore {
	selectedDocumentUrl?: string;
	selectedDocumentId?: string;
	documentKey?: string;
	fileId?: string;
	documentMimeType?: string;
	documentName?: string;
	selectDocument: (
		url: string,
		documentId?: string,
		mimeType?: string,
		name?: string,
	) => void;
	setFileId: (fileId: string | null) => void;
	clearDocument: () => void;
}

export const useDocumentStore = create<DocumentStore>((set) => ({
	selectedDocumentUrl: undefined,
	selectedDocumentId: undefined,
	documentKey: undefined,
	fileId: undefined,
	documentMimeType: undefined,
	documentName: undefined,
	selectDocument: (
		url: string,
		documentId?: string,
		mimeType?: string,
		name?: string,
	) =>
		set({
			selectedDocumentUrl: url,
			selectedDocumentId: documentId,
			fileId: documentId,
			documentMimeType: mimeType,
			documentName: name,
			documentKey: `doc-${Date.now()}-${Math.random()}`,
		}),
	setFileId: (fileId: string | null) => set({ fileId: fileId ?? undefined }),
	clearDocument: () =>
		set({
			selectedDocumentUrl: undefined,
			selectedDocumentId: undefined,
			fileId: undefined,
			documentMimeType: undefined,
			documentName: undefined,
			documentKey: undefined,
		}),
}));
